import { render, staticRenderFns } from "./YandexMapsPage.vue?vue&type=template&id=2be421f4"
import script from "./YandexMapsPage.vue?vue&type=script&lang=js"
export * from "./YandexMapsPage.vue?vue&type=script&lang=js"
import style0 from "./YandexMapsPage.vue?vue&type=style&index=0&id=2be421f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports